
























































































import { Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store'

@Component
export default class UserSettings extends Vue {
  // computed
  get autoLogin() {
    return vxm.core.settings.autoLogin
  }
  set autoLogin(value) {
    vxm.core.setSingleSetting({ key: 'autoLogin', value: value })
  }

  get onlyErrorAlerts() {
    return vxm.core.settings.onlyErrorAlerts
  }
  set onlyErrorAlerts(value) {
    vxm.core.setSingleSetting({ key: 'onlyErrorAlerts', value: value })
    vxm.alerts.setAlert(null)
  }

  get txDelay() {
    return vxm.core.settings.txDelay
  }
  set txDelay(value) {
    vxm.core.setSingleSetting({ key: 'txDelay', value: value })
    if (!value) this.txDelaySec = 0
  }

  get txDelaySec() {
    return vxm.core.settings.txDelaySec
  }
  set txDelaySec(value) {
    vxm.core.setSingleSetting({ key: 'txDelaySec', value: value })
  }

  get showLangSelect() {
    return vxm.core.settings.showLangSelect
  }
  set showLangSelect(value) {
    vxm.core.setSingleSetting({ key: 'showLangSelect', value: value })
  }
  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
